import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  id: {
    store: "Kumamoto Halal Food",
    tagline: "Kasir & Stok",
    nav_kasir: "Kasir Toko",
    nav_meja: "Meja Resto",
    nav_stok: "Stok Barang",
    nav_belanja: "Belanja Stok",
    nav_riwayat: "Riwayat",
    nav_laporan: "Laporan",
    kasir_title: "Kasir Toko",
    kasir_sub: "Penjualan bahan makanan — pilih produk atau scan barcode",
    meja_title: "Meja Resto",
    meja_sub: "Menu restoran — pilih meja untuk membuat atau menutup pesanan",
    meja_menu_sub: "Pilih menu untuk pesanan meja ini",
    all_tables: "Semua Meja",
    add_table: "Tambah Meja",
    empty_table: "Kosong",
    stok_title: "Stok & Produk",
    stok_sub: "Kelola bahan makanan toko dan menu restoran",
    belanja_title: "Belanja Stok",
    belanja_sub: "Catat pembelian bahan dari pemasok — stok otomatis bertambah",
    riwayat_title: "Riwayat Transaksi",
    riwayat_sub: "Klik transaksi untuk melihat struk",
    laporan_title: "Laporan Penjualan",
    laporan_sub: "Ringkasan performa toko & restoran",
    search_placeholder: "Cari produk atau scan barcode lalu Enter...",
    all: "Semua",
    out_of_stock: "Habis",
    cart: "Keranjang",
    cart_sub: "Penjualan langsung",
    new_order: "Pesanan Baru",
    empty_cart: "Belum ada item",
    subtotal: "Subtotal",
    discount: "Diskon",
    total: "Total",
    pay: "Bayar",
    send_to_table: "Kirim ke Meja",
    bill: "Bill Meja",
    pay_bill: "Bayar Bill",
    payment: "Pembayaran",
    total_due: "Total Bayar",
    cash_received: "Uang diterima (¥)",
    change: "Kembalian",
    insufficient: "Uang kurang",
    finish_payment: "Selesaikan Pembayaran",
    success: "Transaksi Berhasil",
    print58: "Cetak 58mm",
    done: "Selesai",
    thanks: "Terima kasih atas kunjungan Anda",
    new_product: "Produk Baru",
    edit_product: "Edit Produk",
    tab_grocery: "Bahan Makanan",
    tab_menu: "Menu Resto",
    name: "Nama",
    category: "Kategori",
    price: "Harga",
    stock: "Stok",
    action: "Aksi",
    low_stock_warn: "produk stoknya menipis",
    save: "Simpan",
    supplier: "Pemasok",
    new_supplier: "Pemasok Baru",
    pick_supplier: "Pilih pemasok",
    add_purchase_item: "Tambah bahan ke daftar belanja",
    purchase_empty: "Belum ada item belanja",
    purchase_total: "Total Belanja",
    save_purchase: "Simpan & Tambah Stok",
    purchase_history: "Riwayat Belanja",
    cancel: "Batalkan",
    no_data: "Belum ada data",
    login: "Masuk",
    register: "Daftar",
    logout: "Keluar",
    password: "Kata sandi (min. 6 karakter)",
    full_name: "Nama lengkap",
    no_account: "Belum punya akun? Daftar",
    have_account: "Sudah punya akun? Masuk",
    guest_note: "Anda tetap bisa pesan tanpa akun.",
    or: "atau",
    search_products_ph: "Cari produk… (mis. ayam, mie, bento)",
    delivery_note_inside:
      "Pesanan dalam Kumamoto shi diantar setelah jam {hour}.00 pada hari pemesanan.",
    delivery_note_outside_today:
      "Anda memesan sebelum jam {hour}.00, jadi pesanan luar Kumamoto shi dikirim hari ini juga.",
    delivery_note_outside_tomorrow:
      "Pesanan luar Kumamoto shi setelah jam {hour}.00 akan dikirim keesokan harinya.",
    search_results_found: "produk ditemukan",
    google_login: "Masuk dengan Google",
    login_ok: "Selamat datang kembali,",
    register_ok: "Akun dibuat. Selamat datang,",
    my_account: "Akun Saya",
    account_sub: "Data Anda tersimpan agar pesanan berikutnya lebih cepat",
    login_required: "Silakan masuk untuk melihat akun Anda.",
    order_history: "Riwayat Pesanan",
    status_new: "Baru",
    status_processing: "Diproses",
    status_done: "Selesai",
    status_cancelled: "Dibatalkan",
    banners: "Banner Promo",
    banner_add: "Tambah banner",
    banner_none: "Belum ada banner",
    banner_title: "Judul banner",
    banner_text: "Teks singkat",
    banner_category: "Kategori tujuan (kosong = semua)",
    banner_hint: "Banner tampil di halaman toko/resto dan bila diklik langsung membuka kategori tujuan",
    banner_start: "Mulai tampil (opsional)",
    banner_end: "Berhenti tampil (opsional)",
    banner_seasonal: "Kosongkan tanggal bila banner ingin tampil terus",
    shop_now: "Belanja sekarang",
    category_hint: "Ketik atau pilih dari kategori yang sudah ada — satu kategori tidak akan terduplikasi",
    manage_cats: "Kelola Kategori",
    manage_cats_hint: "Ganti nama kategori, atau pilih nama kategori lain untuk menggabungkan isinya",
    merge_to: "Gabungkan / ganti nama menjadi",
    merge_btn: "Terapkan",
    merged_ok: "Kategori digabungkan",
    new_category: "+ Kategori baru",
    or_pick_category: "atau pilih kategori yang sudah ada",
    low_stock_title: "Stok menipis",
    stock_all_ok: "Semua stok aman",
    owner_account: "Akun Pemilik",
    owner_account_hint: "Akun yang sedang masuk:",
    current_password: "Kata sandi saat ini",
    new_password: "Kata sandi baru (min. 8 karakter)",
    new_email: "Email baru (opsional)",
    change_password: "Ganti kata sandi",
    tidy_cats: "Rapikan kategori kembar",
    closed_date: "Tanggal tutup",
    qr_title: "QR Kartu Nama",
    photo_saved: "Foto produk tersimpan",
    qr_hint: "Cetak atau tempel QR ini di kasir dan kemasan — pelanggan langsung membuka info toko",
    qr_print: "Cetak QR",
    qr_download: "Unduh gambar QR",
    date_range_invalid: "Tanggal akhir tidak boleh sebelum tanggal mulai",
    chat_whatsapp: "Chat WhatsApp",
    share_store: "Bagikan info toko",
    link_copied: "Tautan disalin",
    open_in_maps: "Buka di Google Maps →",
    photo_missing: "Belum ada foto",
    photo_missing_hint: "Produk tanpa foto — unggah foto asli dagangan agar pembeli lebih yakin",
    password_changed: "Kata sandi diperbarui untuk",
    weight_ph: "Berat / isi (mis. 500 g, 1 kg) — tidak perlu untuk bento",
    reorder: "Pesan ulang",
    reorder_ok: "Keranjang diisi dari pesanan sebelumnya",
    reorder_partial: "Sebagian barang tidak tersedia lagi",
    reorder_none: "Semua barang pesanan itu sudah tidak tersedia",
    city_other: "Kota lain (tarif umum)",
    city_hint: "Pilih kota tujuan — ongkir mengikuti kota yang dipilih",
    outside_cities: "Ongkir per Kota (luar Kumamoto shi)",
    city_name: "Nama kota",
    city_fee: "Ongkir (¥)",
    add_city: "Tambah kota",
    no_city: "Belum ada kota — kota di luar daftar memakai tarif umum",
    owner_login_sub: "Masuk sebagai pemilik toko",
    owner_only: "Akun ini bukan akun pemilik toko",
    nav_label: "Label Harga",
    label_title: "Label Harga Rak",
    label_sub: "Pilih produk, lalu cetak label harga untuk dipasang di rak",
    label_options: "Pengaturan Cetak",
    label_format_a4: "A4 (banyak label)",
    label_format_58: "Thermal 58mm",
    label_ad: "Teks iklan / promo di label (opsional)",
    label_ad_hint: "Teks ini ikut tercetak kecil di bawah harga pada setiap label",
    label_select_all: "Pilih semua",
    label_clear: "Kosongkan",
    label_selected: "dipilih",
    label_print: "Cetak Label",
    search_product: "Cari produk...",
    cust_email: "Email (opsional, untuk notifikasi)",
    today_revenue: "Penjualan Hari Ini",
    today_orders: "Transaksi Hari Ini",
    month_revenue: "Penjualan Bulan Ini",
    month_purchase: "Belanja Stok Bulan Ini",
    chart_7d: "Penjualan 7 Hari Terakhir",
    top_items: "Produk Terlaris",
    by_method: "Per Metode Pembayaran",
    low_stock: "Stok Menipis",
    stock_ok: "Semua stok aman",
    from: "Dari",
    to: "Sampai",
    export: "Ekspor Excel",
    no_tx: "Belum ada transaksi",
    unpaid: "Belum bayar",
    retail: "Toko",
    dine_in: "Resto",
    items: "item",
    pm_cash: "Tunai",
    pm_paypay: "PayPay",
    pm_credit_card: "Kartu Kredit",
    pm_japan_post_bank: "Japan Post Bank",
    loading: "Memuat...",
    nav_online: "Pesanan Online",
    nav_settings: "Pengaturan",
    online_title: "Pesanan Online",
    online_sub: "Pesanan pelanggan dari belanja online & resto",
    toko_title: "Belanja Online",
    toko_sub: "Pesan bahan makanan halal, diantar atau ambil sendiri",
    browse_category: "Pilih Kategori",
    featured_products: "Pilihan Toko",
    new_arrivals: "Produk Terbaru",
    wa_float_label: "Chat WhatsApp",
    flash_label: "Diskon Kilat",
    code_copied: "Kode disalin",
    days: "Hari",
    hours: "Jam",
    minutes: "Menit",
    seconds: "Detik",
    share_wa: "Bagikan ke WhatsApp",
    back_to_shop: "Kembali ke katalog",
    product_not_found: "Produk tidak ditemukan",
    add_to_cart: "Tambah ke keranjang",
    added_to_cart: "ditambahkan ke keranjang",
    in_stock: "Tersedia",
    related_products: "Produk serupa",
    detail_link: "Lihat detail",
    resto_title: "Pesan Menu Resto",
    resto_note_title: "Catatan penting pemesanan bento",
    menu_today: "Menu Hari Ini",
    bento_pickup_only: "Keranjang berisi bento — hanya bisa diambil di toko, tidak bisa diantar.",
    resto_note_daily: "Menu berubah setiap hari — silakan lihat daftar menu hari ini.",
    resto_note_pickup:
      "Pesanan bento mengikuti menu hari itu dan diambil sendiri di toko.",
    resto_note_no_lunch_delivery: "Tidak ada pengiriman bento pada siang hari.",
    resto_sub: "Menu restoran & bento, siap diambil atau diantar",
    checkout: "Data Pemesan",
    cust_name: "Nama pemesan",
    cust_phone: "No. telepon",
    cust_whatsapp: "No. WhatsApp",
    wa_same_as_phone: "Nomor WhatsApp sama dengan nomor telepon",
    contact_store_wa: "Hubungi toko via WhatsApp",
    cust_address: "Alamat pengiriman",
    cust_note: "Catatan (opsional)",
    delivery: "Diantar",
    pickup: "Ambil sendiri",
    place_order: "Kirim Pesanan",
    order_placed: "Pesanan terkirim, kami akan menghubungi Anda",
    st_new: "Baru",
    st_processing: "Diproses",
    st_done: "Selesai",
    st_cancelled: "Dibatalkan",
    mark_processing: "Proses",
    mark_done: "Selesaikan",
    settings_title: "Pengaturan Toko",
    settings_sub: "Jam buka & pemberitahuan hari libur",
    business_hours: "Jam Buka",
    holiday_notice: "Pemberitahuan Hari Libur",
    closed: "Tutup",
    save_settings: "Simpan Pengaturan",
    saved: "Pengaturan disimpan",
    open_today: "Buka hari ini",
    closed_today: "Tutup hari ini",
    go_store: "Belanja Bahan",
    go_resto: "Menu Resto",
    owner_area: "Area Pemilik",
    channel_grocery: "Belanja Bahan",
    channel_resto: "Menu Resto",
    no_online_orders: "Belum ada pesanan online",
    notifications: "Notifikasi",
    all_clear: "Tidak ada peringatan",
    new_online_orders: "pesanan online baru",
    out_stock_warn: "produk habis",
    unit: "Satuan",
    daily_stock: "Stok harian (reset 08:00)",
    delivery_fee: "Ongkos kirim (¥)",
    store_info: "Data Toko",
    store_name: "Nama toko",
    store_address: "Alamat toko",
    owner_email: "Email penerima alert",
    owner_whatsapp: "WhatsApp penerima alert",
    delivery_fee_short: "Ongkos kirim",
    zone_inside: "Dalam kota",
    nav_pelanggan: "Pelanggan Setia",
    nav_promo: "Kupon Promo",
    promo_title: "Kupon Promo",
    promo_sub: "Kode diskon berbatas waktu untuk menarik pembeli",
    promo_new: "Buat Kupon",
    promo_code: "Kode (mis. HARIRABU)",
    promo_percent: "Diskon persen",
    promo_amount: "Diskon nominal",
    promo_min: "Min. belanja",
    promo_limit: "Batas pemakaian",
    promo_active: "Aktif",
    promo_expired: "Kedaluwarsa",
    promo_used_up: "Kuota habis",
    promo_scheduled: "Terjadwal",
    promo_apply: "Punya kode promo?",
    promo_discount: "Diskon promo",
    promo_ok: "Kode promo dipakai",
    birthday: "Ulang tahun",
    birthday_pct: "Diskon ulang tahun (%)",
    email: "Email",
    loyalty_title: "Pelanggan Setia",
    loyalty_sub: "Diskon otomatis untuk pembelian berulang",
    loyalty_settings: "Program Pelanggan Setia",
    tier: "Tingkat",
    loyalty_discount: "Diskon pelanggan setia",
    loyalty_welcome: "Selamat! Anda dapat diskon",
    zone_outside: "Luar kota",
    min_order: "Minimal belanja untuk antar (¥)",
    min_order_warn: "Minimal belanja untuk pengiriman",
    outside_fee: "Ongkos kirim luar area (¥)",
    outside_label: "Nama area luar",
    upload_photo: "Unggah foto",
    uploading: "Mengunggah...",
    or_paste_url: "atau tempel URL foto",
    delivery_area: "Area pengiriman",
    delivery_fee_note: "Ongkos kirim berlaku untuk pengiriman dalam area",
    photo_url: "URL foto barang",
    status_updated: "Status pesanan diperbarui",
    profit_title: "Laporan Laba",
    profit_sub: "Untung per produk dari selisih harga beli dan jual",
    revenue: "Pendapatan",
    cost: "Harga beli",
    profit: "Laba",
    margin: "Margin",
    qty_sold: "Terjual",
    nav_laba: "Laporan Laba",
    min_threshold: "Batas minimum",
    share_location: "Bagikan lokasi saya",
    location_shared: "Lokasi dibagikan",
    geo_denied: "Izin lokasi ditolak",
    geo_unsupported: "Perangkat tidak mendukung lokasi",
    open_map: "Lihat di peta",
    store_phone: "Telepon toko",
    alert_channels: "Alert stok menipis",
    test_alert: "Kirim alert uji",
    weekday_names: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
  },
  ja: {
    store: "Kumamoto Halal Food",
    tagline: "レジ・在庫管理",
    nav_kasir: "店舗レジ",
    nav_meja: "レストラン席",
    nav_stok: "在庫・商品",
    nav_belanja: "仕入れ",
    nav_riwayat: "取引履歴",
    nav_laporan: "レポート",
    kasir_title: "店舗レジ",
    kasir_sub: "食材の販売 — 商品を選ぶかバーコードをスキャン",
    meja_title: "レストラン席",
    meja_sub: "レストランメニュー — 席を選んで注文・会計",
    meja_menu_sub: "この席の注文メニューを選択",
    all_tables: "席一覧",
    add_table: "席を追加",
    empty_table: "空席",
    stok_title: "在庫・商品",
    stok_sub: "食材と レストランメニューの管理",
    belanja_title: "仕入れ",
    belanja_sub: "仕入れを記録すると在庫が自動で増えます",
    riwayat_title: "取引履歴",
    riwayat_sub: "取引をタップしてレシートを表示",
    laporan_title: "売上レポート",
    laporan_sub: "店舗とレストランの実績まとめ",
    search_placeholder: "商品検索 / バーコードをスキャンしてEnter...",
    all: "すべて",
    out_of_stock: "在庫切れ",
    cart: "カート",
    cart_sub: "店頭販売",
    new_order: "新規注文",
    empty_cart: "商品がありません",
    subtotal: "小計",
    discount: "割引",
    total: "合計",
    pay: "支払い",
    send_to_table: "席に送信",
    bill: "席の伝票",
    pay_bill: "会計する",
    payment: "お支払い",
    total_due: "お支払い金額",
    cash_received: "お預かり (¥)",
    change: "お釣り",
    insufficient: "金額が不足",
    finish_payment: "支払いを完了",
    success: "取引完了",
    print58: "58mm印刷",
    done: "完了",
    thanks: "ご来店ありがとうございました",
    new_product: "新規商品",
    edit_product: "商品を編集",
    tab_grocery: "食材",
    tab_menu: "レストランメニュー",
    name: "名称",
    category: "カテゴリ",
    price: "価格",
    stock: "在庫",
    action: "操作",
    low_stock_warn: "点の在庫が少なくなっています",
    save: "保存",
    supplier: "仕入先",
    new_supplier: "仕入先を追加",
    pick_supplier: "仕入先を選択",
    add_purchase_item: "仕入れリストに商品を追加",
    purchase_empty: "仕入れ商品がありません",
    purchase_total: "仕入れ合計",
    save_purchase: "保存して在庫に追加",
    purchase_history: "仕入れ履歴",
    cancel: "取消",
    no_data: "データがありません",
    login: "ログイン",
    register: "新規登録",
    logout: "ログアウト",
    password: "パスワード（6文字以上）",
    full_name: "お名前",
    no_account: "アカウントがない方はこちら",
    have_account: "すでに登録済みの方はログイン",
    guest_note: "アカウントなしでもご注文いただけます。",
    or: "または",
    search_products_ph: "商品を検索… (例：チキン、麺、弁当)",
    delivery_note_inside: "熊本市内へのお届けは、ご注文日の{hour}時以降となります。",
    delivery_note_outside_today: "{hour}時までのご注文のため、熊本市外へも本日中に発送いたします。",
    delivery_note_outside_tomorrow: "{hour}時以降の熊本市外へのご注文は、翌日の発送となります。",
    search_results_found: "件の商品",
    google_login: "Googleでログイン",
    login_ok: "おかえりなさい、",
    register_ok: "アカウントを作成しました。ようこそ、",
    my_account: "マイアカウント",
    account_sub: "次回のご注文が早くなるよう情報を保存します",
    login_required: "アカウント情報を見るにはログインしてください。",
    order_history: "注文履歴",
    status_new: "新規",
    status_processing: "準備中",
    status_done: "完了",
    status_cancelled: "キャンセル",
    banners: "プロモバナー",
    banner_add: "バナーを追加",
    banner_none: "バナーがありません",
    banner_title: "バナーの見出し",
    banner_text: "短い説明",
    banner_category: "移動先カテゴリー（空欄=すべて）",
    banner_hint: "バナーは店舗・レストランのページに表示され、クリックすると対象カテゴリーが開きます",
    banner_start: "表示開始日（任意）",
    banner_end: "表示終了日（任意）",
    banner_seasonal: "常時表示したい場合は日付を空欄にしてください",
    shop_now: "今すぐ購入",
    category_hint: "既存のカテゴリーから選択または入力してください。カテゴリー名は重複しません",
    manage_cats: "カテゴリー管理",
    manage_cats_hint: "カテゴリー名を変更、または他の名前を選んで統合します",
    merge_to: "統合・名称変更の先",
    merge_btn: "適用",
    merged_ok: "カテゴリーを統合しました",
    new_category: "＋ 新しいカテゴリー",
    or_pick_category: "または既存のカテゴリーを選択",
    low_stock_title: "在庫わずか",
    stock_all_ok: "在庫は十分です",
    owner_account: "オーナーアカウント",
    owner_account_hint: "ログイン中のアカウント：",
    current_password: "現在のパスワード",
    new_password: "新しいパスワード（8文字以上）",
    new_email: "新しいメール（任意）",
    change_password: "パスワードを変更",
    tidy_cats: "重複カテゴリーを整理",
    closed_date: "休業日",
    qr_title: "QRショップカード",
    photo_saved: "商品写真を保存しました",
    qr_hint: "レジや商品パッケージに貼れます。お客様はすぐに店舗情報を開けます",
    qr_print: "QRを印刷",
    qr_download: "QR画像を保存",
    date_range_invalid: "終了日は開始日より前にできません",
    chat_whatsapp: "WhatsAppで連絡",
    share_store: "店舗情報を共有",
    link_copied: "リンクをコピーしました",
    open_in_maps: "Googleマップで開く →",
    photo_missing: "写真なし",
    photo_missing_hint: "写真のない商品です。実際の商品写真を登録すると購入されやすくなります",
    password_changed: "パスワードを更新しました：",
    weight_ph: "重量・内容量（例: 500g、1kg）弁当は不要",
    reorder: "再注文",
    reorder_ok: "前回のご注文をカートに入れました",
    reorder_partial: "一部の商品は在庫切れのため除外しました",
    reorder_none: "以前のご注文の商品はすべて在庫切れです",
    city_other: "その他の市町（標準料金）",
    city_hint: "配達先の市町を選択してください。送料は市町ごとに変わります",
    outside_cities: "市町ごとの送料（熊本市外）",
    city_name: "市町名",
    city_fee: "送料（¥）",
    add_city: "市町を追加",
    no_city: "登録なし — 一覧にない市町は標準料金です",
    owner_login_sub: "店舗オーナーとしてログイン",
    owner_only: "このアカウントはオーナーではありません",
    nav_label: "価格ラベル",
    label_title: "棚用価格ラベル",
    label_sub: "商品を選んで、棚に貼る価格ラベルを印刷します",
    label_options: "印刷設定",
    label_format_a4: "A4（複数ラベル）",
    label_format_58: "サーマル58mm",
    label_ad: "ラベルの広告・宣伝文（任意）",
    label_ad_hint: "この文は各ラベルの価格の下に小さく印刷されます",
    label_select_all: "すべて選択",
    label_clear: "選択解除",
    label_selected: "件選択",
    label_print: "ラベルを印刷",
    search_product: "商品を検索...",
    cust_email: "メール（任意・通知用）",
    today_revenue: "本日の売上",
    today_orders: "本日の取引数",
    month_revenue: "今月の売上",
    month_purchase: "今月の仕入れ",
    chart_7d: "直近7日間の売上",
    top_items: "人気商品",
    by_method: "支払方法別",
    low_stock: "在庫僅少",
    stock_ok: "在庫は十分です",
    from: "開始日",
    to: "終了日",
    export: "Excel出力",
    no_tx: "取引がありません",
    unpaid: "未払い",
    retail: "店舗",
    dine_in: "店内",
    items: "点",
    pm_cash: "現金",
    pm_paypay: "PayPay",
    pm_credit_card: "クレジットカード",
    pm_japan_post_bank: "ゆうちょ銀行振込",
    loading: "読み込み中...",
    nav_online: "オンライン注文",
    nav_settings: "設定",
    online_title: "オンライン注文",
    online_sub: "オンライン食材・レストラン注文の一覧",
    toko_title: "オンラインショップ",
    toko_sub: "ハラル食材のご注文 — 配達または店頭受取",
    browse_category: "カテゴリーを選ぶ",
    featured_products: "おすすめ商品",
    new_arrivals: "新着商品",
    wa_float_label: "WhatsAppで相談",
    flash_label: "タイムセール",
    code_copied: "コードをコピーしました",
    days: "日",
    hours: "時間",
    minutes: "分",
    seconds: "秒",
    share_wa: "WhatsAppで共有",
    back_to_shop: "商品一覧に戻る",
    product_not_found: "商品が見つかりません",
    add_to_cart: "カートに追加",
    added_to_cart: "をカートに追加しました",
    in_stock: "在庫あり",
    related_products: "関連商品",
    detail_link: "詳細を見る",
    resto_title: "レストラン注文",
    resto_note_title: "お弁当のご注文に関する大切なお知らせ",
    menu_today: "本日のメニュー",
    bento_pickup_only: "カートにお弁当が入っています。店頭でのお受け取りのみとなります。",
    resto_note_daily: "メニューは毎日変わります。本日のメニューをご確認ください。",
    resto_note_pickup: "お弁当は当日のメニューからのご注文で、店舗でのお受け取りとなります。",
    resto_note_no_lunch_delivery: "お昼のお弁当の配達は行っておりません。",
    resto_sub: "レストランメニュー・お弁当のご注文",
    checkout: "ご注文者情報",
    cust_name: "お名前",
    cust_phone: "電話番号",
    cust_whatsapp: "WhatsApp番号",
    wa_same_as_phone: "WhatsApp番号は電話番号と同じ",
    contact_store_wa: "WhatsAppで店舗に問い合わせ",
    cust_address: "配達先住所",
    cust_note: "備考（任意）",
    delivery: "配達",
    pickup: "店頭受取",
    place_order: "注文を送信",
    order_placed: "ご注文を受け付けました",
    st_new: "新規",
    st_processing: "対応中",
    st_done: "完了",
    st_cancelled: "キャンセル",
    mark_processing: "対応する",
    mark_done: "完了にする",
    settings_title: "店舗設定",
    settings_sub: "営業時間と定休日のお知らせ",
    business_hours: "営業時間",
    holiday_notice: "定休日のお知らせ",
    closed: "定休日",
    save_settings: "設定を保存",
    saved: "設定を保存しました",
    open_today: "本日営業",
    closed_today: "本日休業",
    go_store: "食材を注文",
    go_resto: "レストラン",
    owner_area: "管理画面",
    channel_grocery: "食材",
    channel_resto: "レストラン",
    no_online_orders: "オンライン注文はありません",
    notifications: "通知",
    all_clear: "警告はありません",
    new_online_orders: "件の新規オンライン注文",
    out_stock_warn: "点が在庫切れ",
    unit: "単位",
    daily_stock: "1日の在庫（8時にリセット）",
    delivery_fee: "配送料 (¥)",
    store_info: "店舗情報",
    store_name: "店舗名",
    store_address: "店舗住所",
    owner_email: "アラート受信メール",
    owner_whatsapp: "アラート受信WhatsApp",
    delivery_fee_short: "配送料",
    zone_inside: "市内",
    nav_pelanggan: "会員顧客",
    nav_promo: "クーポン",
    promo_title: "クーポン",
    promo_sub: "期間限定の割引コード",
    promo_new: "クーポンを作成",
    promo_code: "コード",
    promo_percent: "％割引",
    promo_amount: "金額割引",
    promo_min: "最低購入額",
    promo_limit: "利用上限",
    promo_active: "有効",
    promo_expired: "期限切れ",
    promo_used_up: "上限到達",
    promo_scheduled: "予約済み",
    promo_apply: "クーポンコード",
    promo_discount: "クーポン割引",
    promo_ok: "クーポンを適用しました",
    birthday: "誕生日",
    birthday_pct: "誕生日割引 (%)",
    email: "メール",
    loyalty_title: "会員顧客",
    loyalty_sub: "リピーターへの自動割引",
    loyalty_settings: "会員プログラム",
    tier: "ランク",
    loyalty_discount: "会員割引",
    loyalty_welcome: "割引が適用されます",
    zone_outside: "市外",
    min_order: "配達の最低注文額 (¥)",
    min_order_warn: "配達の最低注文額",
    outside_fee: "市外の配送料 (¥)",
    outside_label: "市外エリア名",
    upload_photo: "写真をアップロード",
    uploading: "アップロード中...",
    or_paste_url: "または写真URLを貼り付け",
    delivery_area: "配達エリア",
    delivery_fee_note: "配送料は次のエリア内の配達に適用されます",
    photo_url: "商品写真のURL",
    status_updated: "注文ステータスを更新しました",
    profit_title: "利益レポート",
    profit_sub: "商品ごとの仕入れ値と売値の差益",
    revenue: "売上",
    cost: "仕入れ",
    profit: "利益",
    margin: "利益率",
    qty_sold: "販売数",
    nav_laba: "利益レポート",
    min_threshold: "最小在庫",
    share_location: "現在地を共有",
    location_shared: "位置情報を共有しました",
    geo_denied: "位置情報が拒否されました",
    geo_unsupported: "位置情報に未対応の端末です",
    open_map: "地図で見る",
    store_phone: "店舗電話",
    alert_channels: "在庫アラート",
    test_alert: "テスト通知を送信",
    weekday_names: ["日", "月", "火", "水", "木", "金", "土"],
  },
  en: {
    store: "Kumamoto Halal Food",
    tagline: "POS & Inventory",
    nav_kasir: "Store POS",
    nav_meja: "Restaurant Tables",
    nav_stok: "Inventory",
    nav_belanja: "Stock Purchase",
    nav_riwayat: "History",
    nav_laporan: "Reports",
    kasir_title: "Store POS",
    kasir_sub: "Grocery sales — pick a product or scan a barcode",
    meja_title: "Restaurant Tables",
    meja_sub: "Restaurant menu — pick a table to open or close a bill",
    meja_menu_sub: "Pick menu items for this table",
    all_tables: "All Tables",
    add_table: "Add Table",
    empty_table: "Empty",
    stok_title: "Inventory & Products",
    stok_sub: "Manage groceries and restaurant menu",
    belanja_title: "Stock Purchase",
    belanja_sub: "Record supplier purchases — stock increases automatically",
    riwayat_title: "Transaction History",
    riwayat_sub: "Tap a transaction to view its receipt",
    laporan_title: "Sales Reports",
    laporan_sub: "Store & restaurant performance summary",
    search_placeholder: "Search product or scan barcode then Enter...",
    all: "All",
    out_of_stock: "Out",
    cart: "Cart",
    cart_sub: "Direct sale",
    new_order: "New Order",
    empty_cart: "No items yet",
    subtotal: "Subtotal",
    discount: "Discount",
    total: "Total",
    pay: "Pay",
    send_to_table: "Send to Table",
    bill: "Table Bill",
    pay_bill: "Pay Bill",
    payment: "Payment",
    total_due: "Amount Due",
    cash_received: "Cash received (¥)",
    change: "Change",
    insufficient: "Not enough cash",
    finish_payment: "Complete Payment",
    success: "Transaction Complete",
    print58: "Print 58mm",
    done: "Done",
    thanks: "Thank you for your visit",
    new_product: "New Product",
    edit_product: "Edit Product",
    tab_grocery: "Groceries",
    tab_menu: "Restaurant Menu",
    name: "Name",
    category: "Category",
    price: "Price",
    stock: "Stock",
    action: "Actions",
    low_stock_warn: "products are running low",
    save: "Save",
    supplier: "Supplier",
    new_supplier: "New Supplier",
    pick_supplier: "Select supplier",
    add_purchase_item: "Add item to purchase list",
    purchase_empty: "No purchase items yet",
    purchase_total: "Purchase Total",
    save_purchase: "Save & Add Stock",
    purchase_history: "Purchase History",
    cancel: "Cancel",
    no_data: "No data yet",
    login: "Sign in",
    register: "Sign up",
    logout: "Sign out",
    password: "Password (min. 6 characters)",
    full_name: "Full name",
    no_account: "No account yet? Sign up",
    have_account: "Already registered? Sign in",
    guest_note: "You can still order without an account.",
    or: "or",
    search_products_ph: "Search products… (e.g. chicken, noodles, bento)",
    delivery_note_inside:
      "Orders inside Kumamoto shi are delivered after {hour}:00 on the order day.",
    delivery_note_outside_today:
      "You ordered before {hour}:00, so orders outside Kumamoto shi ship today.",
    delivery_note_outside_tomorrow:
      "Orders outside Kumamoto shi placed after {hour}:00 will be shipped the next day.",
    search_results_found: "products found",
    google_login: "Sign in with Google",
    login_ok: "Welcome back,",
    register_ok: "Account created. Welcome,",
    my_account: "My Account",
    account_sub: "We save your details so your next order is faster",
    login_required: "Please sign in to view your account.",
    order_history: "Order History",
    status_new: "New",
    status_processing: "Processing",
    status_done: "Completed",
    status_cancelled: "Cancelled",
    banners: "Promo Banners",
    banner_add: "Add banner",
    banner_none: "No banners yet",
    banner_title: "Banner headline",
    banner_text: "Short text",
    banner_category: "Target category (empty = all)",
    banner_hint: "Banners appear on the store/restaurant pages and open the target category when clicked",
    banner_start: "Show from (optional)",
    banner_end: "Show until (optional)",
    banner_seasonal: "Leave the dates empty to show the banner all the time",
    shop_now: "Shop now",
    category_hint: "Type or pick an existing category — category names are never duplicated",
    manage_cats: "Manage Categories",
    manage_cats_hint: "Rename a category, or pick another name to merge its items into it",
    merge_to: "Merge / rename into",
    merge_btn: "Apply",
    merged_ok: "Categories merged",
    new_category: "+ New category",
    or_pick_category: "or pick an existing category",
    low_stock_title: "Low stock",
    stock_all_ok: "All stock levels are fine",
    owner_account: "Owner Account",
    owner_account_hint: "Signed in as:",
    current_password: "Current password",
    new_password: "New password (min. 8 characters)",
    new_email: "New email (optional)",
    change_password: "Change password",
    tidy_cats: "Tidy duplicate categories",
    closed_date: "Closed date",
    qr_title: "QR Business Card",
    photo_saved: "Product photo saved",
    qr_hint: "Print or stick this QR at the till and on packaging — customers open your store info instantly",
    qr_print: "Print QR",
    qr_download: "Download QR image",
    date_range_invalid: "End date cannot be before the start date",
    chat_whatsapp: "Chat on WhatsApp",
    share_store: "Share store info",
    link_copied: "Link copied",
    open_in_maps: "Open in Google Maps →",
    photo_missing: "No photo yet",
    photo_missing_hint: "Products without a photo — upload real photos so shoppers trust the store",
    password_changed: "Password updated for",
    weight_ph: "Weight / net content (e.g. 500 g, 1 kg) — not needed for bento",
    reorder: "Order again",
    reorder_ok: "Cart filled from your previous order",
    reorder_partial: "Some items are no longer available",
    reorder_none: "Every item from that order is unavailable now",
    city_other: "Other city (standard fee)",
    city_hint: "Pick the destination city — the fee follows the chosen city",
    outside_cities: "Delivery fee per city (outside Kumamoto shi)",
    city_name: "City name",
    city_fee: "Fee (¥)",
    add_city: "Add city",
    no_city: "No cities yet — cities outside the list use the standard fee",
    owner_login_sub: "Sign in as store owner",
    owner_only: "This account is not a store owner",
    nav_label: "Price Labels",
    label_title: "Shelf Price Labels",
    label_sub: "Pick products, then print price labels for your shelves",
    label_options: "Print Options",
    label_format_a4: "A4 (many labels)",
    label_format_58: "Thermal 58mm",
    label_ad: "Ad / promo text on label (optional)",
    label_ad_hint: "This text is printed small under the price on every label",
    label_select_all: "Select all",
    label_clear: "Clear",
    label_selected: "selected",
    label_print: "Print Labels",
    search_product: "Search product...",
    cust_email: "Email (optional, for notifications)",
    today_revenue: "Today's Sales",
    today_orders: "Today's Orders",
    month_revenue: "This Month's Sales",
    month_purchase: "This Month's Purchases",
    chart_7d: "Sales Last 7 Days",
    top_items: "Best Sellers",
    by_method: "By Payment Method",
    low_stock: "Low Stock",
    stock_ok: "All stock is healthy",
    from: "From",
    to: "To",
    export: "Export Excel",
    no_tx: "No transactions yet",
    unpaid: "Unpaid",
    retail: "Store",
    dine_in: "Dine-in",
    items: "items",
    pm_cash: "Cash",
    pm_paypay: "PayPay",
    pm_credit_card: "Credit Card",
    pm_japan_post_bank: "Japan Post Bank",
    loading: "Loading...",
    nav_online: "Online Orders",
    nav_settings: "Settings",
    online_title: "Online Orders",
    online_sub: "Customer orders from the online shop & restaurant",
    toko_title: "Online Grocery Shop",
    toko_sub: "Order halal groceries for delivery or pickup",
    browse_category: "Browse by category",
    featured_products: "Store picks",
    new_arrivals: "New arrivals",
    wa_float_label: "Chat on WhatsApp",
    flash_label: "Flash sale",
    code_copied: "Code copied",
    days: "Days",
    hours: "Hours",
    minutes: "Min",
    seconds: "Sec",
    share_wa: "Share on WhatsApp",
    back_to_shop: "Back to catalog",
    product_not_found: "Product not found",
    add_to_cart: "Add to cart",
    added_to_cart: "added to cart",
    in_stock: "In stock",
    related_products: "Related products",
    detail_link: "View details",
    resto_title: "Restaurant Ordering",
    resto_note_title: "Important note for bento orders",
    menu_today: "Today's Menu",
    bento_pickup_only: "Your cart contains bento — pickup only, delivery is not available.",
    resto_note_daily: "The menu changes every day — please check today's menu.",
    resto_note_pickup: "Bento orders follow that day's menu and are picked up at the shop.",
    resto_note_no_lunch_delivery: "There is no bento delivery at lunchtime.",
    resto_sub: "Restaurant menu & bento, pickup or delivery",
    checkout: "Customer Details",
    cust_name: "Your name",
    cust_phone: "Phone number",
    cust_whatsapp: "WhatsApp number",
    wa_same_as_phone: "WhatsApp number is the same as my phone",
    contact_store_wa: "Contact the store on WhatsApp",
    cust_address: "Delivery address",
    cust_note: "Note (optional)",
    delivery: "Delivery",
    pickup: "Pickup",
    place_order: "Place Order",
    order_placed: "Order sent, we will contact you shortly",
    st_new: "New",
    st_processing: "Processing",
    st_done: "Done",
    st_cancelled: "Cancelled",
    mark_processing: "Process",
    mark_done: "Complete",
    settings_title: "Store Settings",
    settings_sub: "Business hours & holiday notice",
    business_hours: "Business Hours",
    holiday_notice: "Holiday Notice",
    closed: "Closed",
    save_settings: "Save Settings",
    saved: "Settings saved",
    open_today: "Open today",
    closed_today: "Closed today",
    go_store: "Shop Groceries",
    go_resto: "Restaurant",
    owner_area: "Owner Area",
    channel_grocery: "Groceries",
    channel_resto: "Restaurant",
    no_online_orders: "No online orders yet",
    notifications: "Notifications",
    all_clear: "No alerts",
    new_online_orders: "new online orders",
    out_stock_warn: "products out of stock",
    unit: "Unit",
    daily_stock: "Daily stock (reset 08:00)",
    delivery_fee: "Delivery fee (¥)",
    store_info: "Store Details",
    store_name: "Store name",
    store_address: "Store address",
    owner_email: "Alert email",
    owner_whatsapp: "Alert WhatsApp",
    delivery_fee_short: "Delivery fee",
    zone_inside: "Inside city",
    nav_pelanggan: "Loyal Customers",
    nav_promo: "Promo Coupons",
    promo_title: "Promo Coupons",
    promo_sub: "Time-limited discount codes to bring buyers in",
    promo_new: "Create Coupon",
    promo_code: "Code",
    promo_percent: "Percent off",
    promo_amount: "Amount off",
    promo_min: "Min. spend",
    promo_limit: "Usage limit",
    promo_active: "Active",
    promo_expired: "Expired",
    promo_used_up: "Limit reached",
    promo_scheduled: "Scheduled",
    promo_apply: "Have a promo code?",
    promo_discount: "Promo discount",
    promo_ok: "Promo code applied",
    birthday: "Birthday",
    birthday_pct: "Birthday discount (%)",
    email: "Email",
    loyalty_title: "Loyal Customers",
    loyalty_sub: "Automatic discounts for repeat buyers",
    loyalty_settings: "Loyalty Programme",
    tier: "Tier",
    loyalty_discount: "Loyalty discount",
    loyalty_welcome: "You get a discount of",
    zone_outside: "Outside city",
    min_order: "Minimum order for delivery (¥)",
    min_order_warn: "Minimum order for delivery",
    outside_fee: "Outside-area delivery fee (¥)",
    outside_label: "Outside area name",
    upload_photo: "Upload photo",
    uploading: "Uploading...",
    or_paste_url: "or paste a photo URL",
    delivery_area: "Delivery area",
    delivery_fee_note: "Delivery fee applies to deliveries inside",
    photo_url: "Product photo URL",
    status_updated: "Order status updated",
    profit_title: "Profit Report",
    profit_sub: "Profit per product from buy vs sell price",
    revenue: "Revenue",
    cost: "Cost",
    profit: "Profit",
    margin: "Margin",
    qty_sold: "Sold",
    nav_laba: "Profit Report",
    min_threshold: "Min. threshold",
    share_location: "Share my location",
    location_shared: "Location shared",
    geo_denied: "Location permission denied",
    geo_unsupported: "Location not supported on this device",
    open_map: "Open in maps",
    store_phone: "Store phone",
    alert_channels: "Low-stock alerts",
    test_alert: "Send test alert",
    weekday_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  },
};

export const CATEGORY_JA = {
  Daging: "肉類",
  Sayuran: "野菜",
  Bumbu: "調味料",
  Minuman: "飲み物",
  Bento: "弁当",
  Nasi: "ご飯",
  Ramen: "ラーメン",
  Camilan: "軽食",
  "Beras & Mie": "米・麺",
  "Segar Halal": "ハラル生鮮",
  Lainnya: "その他",
};

export const catLabel = (cat, lang) =>
  (lang === "ja" && CATEGORY_JA[cat]) || cat;

export const LANGS = [
  { id: "id", label: "ID", name: "Indonesia" },
  { id: "ja", label: "JA", name: "日本語" },
  { id: "en", label: "EN", name: "English" },
];

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("khf_lang") || "id");
  useEffect(() => {
    localStorage.setItem("khf_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => dict[lang][key] ?? dict.id[key] ?? key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
